import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MapPin } from "lucide-react";
import { Reveal, Arrow } from "./Reveal";
import { WA_LINK } from "./data";

const PINS = [[24, 34], [30, 52], [56, 55], [50, 44], [66, 38], [78, 30], [38, 72], [42, 86]];
const KAB = ["Bengkayang", "Kapuas Hulu", "Kayong Utara", "Ketapang", "Kubu Raya", "Landak", "Melawi", "Mempawah", "Sambas", "Sanggau", "Sekadau", "Sintang"];

export const Area = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  return (
    <section ref={ref} id="area" data-testid="area-section" className="relative bg-[#06176b] text-white py-24 overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_40%,rgba(31,139,255,0.35),transparent_60%)]" />
      <div className="relative max-w-[1320px] mx-auto px-5 lg:px-10 grid lg:grid-cols-[1fr_1.6fr] gap-12 items-center">
        <Reveal>
          <p className="eyebrow !text-sky-300">Jangkauan</p>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold mt-2">Area Layanan</h2>
          <p data-testid="area-region" className="font-display text-2xl sm:text-3xl font-extrabold mt-1 text-sky-300">Kalimantan Barat</p>
          <p className="font-display text-xl font-bold mt-3 text-sky-100">Kami Terus Berkembang<br />Lebih Dekat dengan Anda</p>
          <p className="mt-5 text-blue-100 max-w-md leading-relaxed">VISION MEGA NETWORK melayani wilayah Kalimantan Barat dan terus membuka area baru untuk menghadirkan internet berkualitas di lebih banyak lokasi.</p>
          <a href={WA_LINK} target="_blank" rel="noreferrer" data-testid="area-map-btn" className="mt-8 inline-flex items-center gap-2 bg-white text-vnavy font-bold rounded-full px-6 py-3 hover:bg-sky-100 transition-colors">Lihat Peta Area <Arrow /></a>
        </Reveal>
        <div className="relative">
          <motion.div style={{ y }} className="relative rounded-[32px] overflow-hidden aspect-[3/2] ring-1 ring-white/10">
            <img src="/img/kalbar.jpg" alt="Peta area layanan Kalimantan Barat" data-testid="area-map" className="w-full h-full object-cover scale-110" />
            {PINS.map(([x, yy], i) => (
              <span key={i} className="absolute -translate-x-1/2 -translate-y-full" style={{ left: `${x}%`, top: `${yy}%` }}>
                <span className="pin-ping" style={{ animationDelay: `${i * 0.3}s` }} />
                <MapPin size={26} className="relative text-white drop-shadow-[0_0_10px_rgba(125,211,252,1)]" fill="#1f8bff" />
              </span>
            ))}
          </motion.div>
          <Reveal delay={0.2} className="relative z-10 -mt-10 mx-3 sm:mx-6">
            <div data-testid="area-kabupaten" className="bg-white text-vnavy rounded-2xl p-5 sm:p-6 shadow-2xl">
              <p className="font-display font-extrabold text-lg">Tersedia di semua kabupaten <span className="text-vblue">Kalimantan Barat</span></p>
              <ul className="mt-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-3">
                {KAB.map((k) => (
                  <li key={k} data-testid={`kab-${k.toLowerCase().replace(/ /g, "-")}`} className="flex items-center gap-2 text-sm font-semibold"><MapPin size={16} className="text-vblue shrink-0" fill="#dbeafe" /> {k}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
